exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#appBlock{position:fixed;top:0;bottom:0;width:100%;overflow:auto;background-color:rgba(0,0,0,.8);z-index:999}.hidden{display:none}.hideScrollbar{position:absolute;top:0;bottom:0;width:100%;overflow:hidden}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;position:relative;min-width:900px;max-width:85%;margin:auto}.appHeader{margin-top:10px;height:50px;text-align:left;padding-left:15px}.library{float:right;margin-top:5px;font-weight:700}.dropdown-menu{padding:0 5px}.library a{display:inline-block;padding:5px;line-height:24px;font-weight:500}.library .dropdown-divider{height:1px;border-top:1px solid #aaa}::-webkit-input-placeholder{font-style:italic;color:#999}::-moz-placeholder{font-style:italic;color:#999}:-ms-input-placeholder{font-style:italic;color:#999}:-moz-placeholder{font-style:italic;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73fc7a88","scoped":false,"hasInlineConfig":false}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 34
// module chunks = 0